<template>
  <div class="ad-pool-settlement-management">
    <el-card shadow="never" class="animate__animated animate__fadeInUp">
      <div slot="header" class="clearfix">
        <span style="font-size:18px;font-weight:600;">副广池结算流水</span>
      </div>

      <div class="filter-bar">
        <div class="filter-group">
          <el-input
            v-model.trim="searchUserId"
            placeholder="用户 ID"
            prefix-icon="el-icon-user"
            clearable
            class="filter-input filter-input-sm"
            @keyup.enter.native="handleSearch"
          />
          <el-input
            v-model.trim="searchAdRecordId"
            placeholder="广告记录 ID"
            prefix-icon="el-icon-document"
            clearable
            class="filter-input filter-input-sm"
            @keyup.enter.native="handleSearch"
          />
          <el-date-picker
            v-model="searchStartTime"
            type="datetime"
            placeholder="开始时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            clearable
            class="filter-date"
            @change="handleSearch"
          />
          <el-date-picker
            v-model="searchEndTime"
            type="datetime"
            placeholder="结束时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            clearable
            class="filter-date"
            @change="handleSearch"
          />
          <el-button type="primary" icon="el-icon-search" :loading="loading" @click="handleSearch">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
        </div>
      </div>

      <div v-if="error" class="error">{{ error }}</div>

      <el-table
        v-else
        :data="list"
        border
        stripe
        v-loading="loading"
        element-loading-text="正在加载..."
        row-key="id"
      >
        <el-table-column prop="id" label="流水 ID" width="90" align="center" />
        <el-table-column prop="userId" label="用户 ID" width="100" align="center" />
        <el-table-column prop="adRecordId" label="广告记录 ID" width="120" align="center" />
        <el-table-column prop="rewardEcpm" label="激励 ecpm" width="110" align="center" />
        <el-table-column prop="poolEcpm" label="副广池 ecpm" width="120" align="center" />
        <el-table-column prop="rewardUserCoins" label="激励用户金币" width="120" align="center" />
        <el-table-column prop="poolUserCoins" label="副广用户金币" width="120" align="center" />
        <el-table-column prop="totalUserCoins" label="用户总金币" width="110" align="center" />
        <el-table-column prop="createdAt" label="结算时间" width="180" align="center" show-overflow-tooltip />
      </el-table>

      <div v-if="!error && !loading && list.length === 0" class="empty-state">
        <el-empty description="暂无副广池结算流水" />
      </div>

      <div v-if="pagination.total > 0" class="pagination-container">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="pagination.page"
          :page-size="pagination.pageSize"
          :page-sizes="[10, 20, 50, 100]"
          :total="pagination.total"
          @current-change="handlePageChange"
          @size-change="handleSizeChange"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import { get } from '@/utils/http'

export default {
  name: 'AdPoolSettlementManagement',
  data() {
    return {
      loading: false,
      error: '',
      list: [],
      searchUserId: '',
      searchAdRecordId: '',
      searchStartTime: '',
      searchEndTime: '',
      pagination: {
        page: 1,
        pageSize: 20,
        total: 0
      }
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    parsePositiveInt(value) {
      if (value === '' || value == null) {
        return null
      }
      const parsed = parseInt(String(value).trim(), 10)
      return Number.isNaN(parsed) || parsed <= 0 ? null : parsed
    },
    buildQuery() {
      const params = {
        page: this.pagination.page,
        pageSize: this.pagination.pageSize
      }
      const userId = this.parsePositiveInt(this.searchUserId)
      const adRecordId = this.parsePositiveInt(this.searchAdRecordId)
      if (userId != null) {
        params.userId = userId
      }
      if (adRecordId != null) {
        params.adRecordId = adRecordId
      }
      if (this.searchStartTime) {
        params.startTime = this.searchStartTime
      }
      if (this.searchEndTime) {
        params.endTime = this.searchEndTime
      }
      return params
    },
    async fetchList() {
      this.loading = true
      this.error = ''
      try {
        const result = await get('/admin/ad-pool/settlement/page', this.buildQuery())
        const data = result.data || {}
        this.list = Array.isArray(data.records) ? data.records : []
        this.pagination.total = data.total || 0
        this.pagination.page = data.page || this.pagination.page
        this.pagination.pageSize = data.pageSize || this.pagination.pageSize
      } catch (e) {
        this.error = e.message || '加载失败'
        this.list = []
        this.pagination.total = 0
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.pagination.page = 1
      this.fetchList()
    },
    resetSearch() {
      this.searchUserId = ''
      this.searchAdRecordId = ''
      this.searchStartTime = ''
      this.searchEndTime = ''
      this.pagination.page = 1
      this.fetchList()
    },
    refreshList() {
      this.fetchList()
    },
    handlePageChange(page) {
      this.pagination.page = page
      this.fetchList()
    },
    handleSizeChange(size) {
      this.pagination.pageSize = size
      this.pagination.page = 1
      this.fetchList()
    }
  }
}
</script>

<style scoped>
.filter-bar {
  margin-bottom: 16px;
}
.filter-group {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
}
.filter-input-sm {
  width: 160px;
}
.filter-date {
  width: 200px;
}
.pagination-container {
  margin-top: 16px;
  text-align: right;
}
.error {
  color: #f56c6c;
  margin-bottom: 12px;
}
</style>
